import { createStyles } from "@mantine/emotion";

export default createStyles ( {

	emptyChatViewContainer: {
		display        : "flex",
		justifyContent : "center",
		alignItems     : "center",
		height         : "100%",
		textAlign      : "center",
		position       : "relative"
	},
	icon: {
		marginBottom : "10px",
		height       : "12rem",
		width        : "12rem"
	},
	messageText: {
		width  : "100%",
		margin : "auto"
	},
	loaderContainer: {
		position : "absolute",
			 top      : "40%",
			 right    : "35%"
	}
} );

